import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Tipping as TippingProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/tipping';
import Enum from '@square/dashboard-utilities/utils/enum';
import { computed } from '@ember/object';
export const TipCalculationPhases = new Enum(Object.keys(TippingProto.TippingCalculationPhase));
export const TipCustomPercentages = ProtoBaseModel.extend({
  firstAmount: attr(Number),
  secondAmount: attr(Number),
  thirdAmount: attr(Number)
});
export default ProtoBaseModel.extend({
  tippingEnabled: attr(Boolean),
  smartTipsEnabled: attr(Boolean),
  tipCustomPercentages: attr(TipCustomPercentages),
  allowCustomAmounts: attr(Boolean),
  useSeparateTippingScreen: attr(Boolean),
  tipCalculationPhase: attr(TipCalculationPhases),
  displayValueTranslationKey: computed('smartTipsEnabled', 'tippingEnabled', 'tippingUseCustomPercentages', function () {
    if (!this.tippingEnabled) {
      return 'business.devices.profiles.v2.settings.checkout.tipping.enabled.displayValue.off';
    }
    if (this.smartTipsEnabled) {
      return 'business.devices.profiles.v2.settings.checkout.tipping.smartTipping.displayValue.on';
    }
    return 'business.devices.profiles.v2.settings.checkout.tipping.smartTipping.displayValue.off';
  })
});